module.exports = __webpack_public_path__ + "static/map-ab0aa47aedfa8de3c674cb8d42f7dba1.png";